import { Observable } from 'rxjs';

export abstract class FeatureFlagService {
    abstract getFlags(flag: string[]): Observable<any>;
}
